/**
 * Sitemap toggle and accessibility.
 * @type {{attach: Drupal.behaviors.sitemapBlock.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const sitemapBlock_once = once('sitemap-block-once', '.block--sitemap', context);

    $(sitemapBlock_once).each(function () {
      $(this).find('.sitemap__item').each(function() {
        let $button = $(this).find('input.sitemap__collapsible-wrapper');
        let $subitems = $(this).find('.sitemap__subitem-wrapper');
        let buttonLabel = $(this).find('.sitemap__item-title').text().trim();

        $button.attr('aria-label', Drupal.t('Show or hide the submenu items of @title', {'@title': buttonLabel}));

        if ($subitems.length) {
          if ($subitems.css('display') === 'none') {
            $button.attr('aria-expanded', 'false');
          }
          else {
            $button.attr('aria-expanded', 'true');
          }
        }

        $button.on('click', function() {
          $subitems.toggle();

          if ($subitems.css('display') === 'none') {
            $button.attr('aria-expanded', 'false');
          }
          else {
            $button.attr('aria-expanded', 'true');
          }
        });
      });
    });
  },
}
